import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import classes from 'classnames';
import { Button, HelpInfo, Typography } from 'components';
import { isNowHoliday } from 'utils';
import styles from './BankIdError.module.scss';
import useBankIdError from './useBankIdError';

function BankIdError() {
  const { t } = useTranslation();
  const { translation, statusFromRoute, handleSkip } = useBankIdError();

  return (
    <div
      className={classes(
        styles.wrapper,
        statusFromRoute && styles['full-width'],
      )}
      data-test="bank-id-error"
    >
      <Helmet>
        <title>{translation.title}</title>
      </Helmet>
      <Typography
        kind="h1"
        size="xl"
        color="primary"
        className={styles.textCenter}
        dataTest="bankIdError-title"
      >
        {translation.title}
      </Typography>
      <Typography
        size="s"
        className={classes(styles.description, styles.textCenter)}
        dataTest="bankIdError-description"
      >
        {translation.description}
      </Typography>

      <Button
        onClick={handleSkip}
        className={styles.button}
        dataTest="bankIdError-button"
      >
        {translation.button}
      </Button>

      <div className={styles.helpinfo}>
        <HelpInfo
          dataTest="bankIdError-help-info"
          title={t('help_info:title')}
          text={
            isNowHoliday()
              ? t('help_info:contact_details_holiday')
              : t('help_info:contact_details')
          }
        />
      </div>
    </div>
  );
}

export default BankIdError;
